'use strict';

var util = angular.module('gymsystem.util');

util.directive('manualentry', ['$rootScope', 'server', 'util', function($rootScope, server, util) {
    return {
        restrict: 'E',
        template: '<div><ng-include src="\'views/form.html\'"></div>',
        scope: {
            settings: '='
        },
        link: function($scope) {

            $scope.getCustomerForField = $rootScope.getCustomerForField;

            var isActiveDoor = function(s) {
                var sameSite = true;
                if ($rootScope.hasModule('MultiSite') && (s.sites && s.sites.length)) {
                    sameSite = s.sites.indexOf($rootScope.selectedSite.id) !== -1;
                }
                return s.active && s.type == 'resource' && (s.resourceType == 'door' || s.resourceType == 'qrcode_entry') && sameSite;
            };

            var hasDoors = function() {
                return $rootScope.staffs.filter(isActiveDoor).length > 0;
            };

            $scope.fields = [
                {name: 'door', title: 'Door', required: false, type: 'select', visible: hasDoors, options: function() { return $rootScope.staffs; }, optionsFilter: isActiveDoor, placeholder: 'No door choosen' },
                {name: 'customer', title: 'Choose customer', required: false, type: 'customer' }
            ];
            $scope.hideSubmitButton = true;

            var getCustomer = function() {
                return _.findWhere($scope.fields, {name: 'customer'}).value;
            };

            var clearCustomer = function() {
                _.findWhere($scope.fields, { name: 'customer' }).value = null;
            };

            var submit = function() {
                var door = _.findWhere($scope.fields, { name: 'door' }).value;
                var args = { door: door && door.id, customer: getCustomer().id };
                server.post('/api/entry/add', args).then(clearCustomer, clearCustomer);
            };

            $scope.$watch(getCustomer, function(newValue) {
                if (newValue) {
                    submit(newValue);
                }
            });

            $rootScope.waitFor(['staffs']).then(function() {
                if (!$scope.settings.door) { return; }
                var door = _.findWhere($rootScope.staffs, { id: $scope.settings.door });
                util.setValues($scope.fields, { door: door });
            });

        }
    };
}]);
